import type BaseModel from "../../../src/models/BaseModel";
import { ChannelType, getChannelTypePicture } from "../../../src/models/ChannelType";
import { consumerSymbolChannelType } from "../../../src/models/ConsumerDeviceKind";
import { C1_EloItem_Type, type C1_EloItem_Definition, type C1_EloItem_Details } from "../types/C1_EloTypes";
import { channelTypeForDefinition } from "../model/C1_eloChannelType";
import { getC1EloDefinitionIcon } from "./C1_EloDefinitionIcons";

/** Existing equipment uses the navigator's icon API; optional equipment needs no temporary model. */
export function getC1EloEquipmentIcon(
  definition: C1_EloItem_Definition,
  details: C1_EloItem_Details | undefined,
  model?: BaseModel,
) {
  const existing = model?.treeViewModel?.icon;
  if (existing) return existing;
  const catalogIcon = getC1EloDefinitionIcon(definition);
  if (catalogIcon) return catalogIcon;

  let src: string;
  if (definition.type === C1_EloItem_Type.Group || definition.type === C1_EloItem_Type.PlugGroup) {
    return <i className="lab la-codepen" />;
  } else if (definition.type === C1_EloItem_Type.Button || definition.type === C1_EloItem_Type.Sensor) {
    src = state.hostBaseUrl + (definition.type === C1_EloItem_Type.Sensor
      ? "images/consumer/Praesenzmelder.png" : "images/buttons/touch-6.png");
  } else {
    const values = {...definition.defaultDetails, ...details};
    const channelType = channelTypeForDefinition(definition, {details: values});
    const symbolType = consumerSymbolChannelType({channelType, c1:{definition, data:{details: values}}});
    src = getChannelTypePicture(symbolType as ChannelType);
    if (values.isDali && src) src = src.replace(/(\.[^.]+)$/, "_Dali$1");
  }
  return src ? <img src={src} alt="" draggable={false} /> : undefined;
}
